export default __webpack_public_path__ + "static/cloudator-hr-tech-stand-collage-3655b27a24f344eb69e6ff9c6951991d.jpg";